import { render, staticRenderFns } from "./shortpassword.vue?vue&type=template&id=0f4bfa14&"
import script from "./shortpassword.vue?vue&type=script&lang=js&"
export * from "./shortpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports